import React, { useEffect, Fragment, useRef, useState } from "react";
import cx from "classnames";
import DatePicker from "react-datepicker";

const CratioDateTimePicker = (props) => {
  const [selectedDate, setSelectedDate] = useState("");
  useEffect(() => {
    (async () => {
      if (typeof props.value == "string") {
        if (props.value == "current") {
          setSelectedDate(new Date());
        } else if (props.value != "" && props.value != "0000-00-00 00:00:00") {
          setSelectedDate(new Date(props.value));
        }
      } else if (
        typeof props.value == "object" &&
        props.value instanceof Date
      ) {
        setSelectedDate(props.value);
      }
    })();
  }, []);

  const onChange = async (date) => {
    if (props.onChangeEvent) {
      props.onChangeEvent(false, date, props.attributes);
    }
    setSelectedDate(date);
  };

  return (
    <div className={cx(props.customClass)} {...props.attributes}>
      <DatePicker
        dateFormat="yyyy-mm-dd hh:mm a"
        timeFormat="hh:mm a"
        placeholderText="yyyy-mm-dd hh:mm a"
        className={`form-control  ${props.inputClass}`}
        showTimeSelect
        timeIntervals={30}
        timeCaption="Time"
        selected={selectedDate}
        onChange={onChange}
      />
    </div>
  );
};

export default CratioDateTimePicker;
